// extracted by mini-css-extract-plugin
export default {"counter":"NotificationCounter_counter__7Ud71"};